
import { useQuery } from "@tanstack/react-query";
import { campaignsService } from "@/services/campaignsService";

// query keys
export const campaignsQueryKeys = {
  all: ["campaigns"],
  list: () => [...campaignsQueryKeys.all, "list"],
  details: (id) => [...campaignsQueryKeys.all, "detail", id],
};

// get all campaigns
export const useAllCampaigns = (params) => {
  return useQuery({
    queryKey: [...campaignsQueryKeys.list(), params],
    queryFn: () => campaignsService.getAllCampaigns(params),
    enabled: !!params?.company_id,
  });
};

// get campaign by company id pass params
export const useCampaignByCompanyId = (companyId, params) => {
  return useQuery({
    queryKey: campaignsQueryKeys.details(companyId),
    queryFn: () => campaignsService.getCampaignByCompanyId(companyId, params),
    enabled: !!companyId,
  });
};
// get campaign by company id pass params
export const useGetCampaignsList = (companyId, params) => {
  return useQuery({
    queryKey: campaignsQueryKeys.list(companyId),
    queryFn: () => campaignsService.getCampaignsList(companyId, params),
    enabled: !!companyId,
  });
};
export const useGetCampaign = (options = {}, campaignId) => {
  return useQuery({
    queryKey: campaignsQueryKeys.details(campaignId),
    queryFn: () => campaignsService.getCampaign(campaignId),
    ...options
  });
};
